import { getToken,  removeToken } from '@/utils/token'
import { getUser, removeUser } from '@/utils/user'

// 村赤用户令牌和角色信息
const state ={
    token: getToken() || '',
    userInfo: getUser() || ''
}

const mutations ={
    SET_TOKEN: (state,token) => {
        state.token = token;
    },
    USER_INFO(state,info){
        state.userInfo = info
      }
  
};

const actions = {
    addToken({commit},token){
        commit('SET_TOKEN',token)
    },
    // 重置令牌
    resetToken( {commit} ){
            commit('SET_TOKEN','')
            removeToken();
            // resolve()
    },
    //用户信息
    saveUserInfo({ commit },data){
        commit('USER_INFO',data)
      },
    //删除用户
    deleteUser({ commit }){
        commit('USER_INFO','')
        removeUser()
    }
   
  
}

export default {
    // namespaced: true,
    state,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js